export let RegWebsiteManagementHeader = [
    {prop: 'matchName', label: '赛项名称'},
    {prop: 'packetEntryText', label: '竞赛分组', width: 80},
    {prop: 'schemeName', label: '报名计划'},
    {prop: 'isStatusText', label: '报名状态', width: 80},
    {prop: 'updateTime', label: '修改时间'},
]